module.exports = __webpack_public_path__ + "img/LL.8c42edbe.png";